// App.js
import React, { useState, useEffect } from "react";
import { collection, addDoc, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "./firebase";
import "./App.css";

export default function App() {
  const [input, setInput] = useState("");
  const [posts, setPosts] = useState([]);

  // Load posts live from Firestore
  useEffect(() => {
    const q = query(collection(db, "garbage"), orderBy("date", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const items = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setPosts(items);
    });

    return unsubscribe;
  }, []);

  // Submit new post
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    await addDoc(collection(db, "garbage"), {
      content: input.trim(),
      date: new Date(),
    });

    setInput("");
  };

  return (
    <div className="container">
      <div className="slide">
        <h3 className="title">What are you doing here, this is a little dumpster for Gnax's mind, his sadness, his thoughts, his feelings</h3>

        <form className="inputForm" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="What's in your mind"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          <button type="submit">Throw it</button>
        </form>

        <div className="posts">
          {posts.map((post) => (
            <div key={post.id} className="postCard">
              <p>{post.content}</p>
              <span className="date">
                {post.date?.seconds
                  ? new Date(post.date.seconds * 1000).toLocaleString()
                  : new Date(post.date).toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}